import { IconArrowLeft } from "@tabler/icons-react";
import { Link, useNavigate } from "react-router-dom";

import { type ILink } from "../../../interfaces";
import useManagementLinks from "../Breadcrumbs/useManagementLinks";
import { Button } from "../Button/Button";

interface Props {
  fetchLinks?: boolean;
}

const BackToYachtButton = ({ fetchLinks }: Props) => {
  const navigate = useNavigate();
  const { managementLinks, isAuthorizedToSeeLinks } =
    useManagementLinks(fetchLinks);
  if (
    !managementLinks ||
    managementLinks.length === 0 ||
    !isAuthorizedToSeeLinks
  )
    return null;
  return (
    <Button
      mx={10}
      onClick={() => {
        navigate(managementLinks[managementLinks?.length - 2]?.href);
      }}>
      <IconArrowLeft />
      Return to Yacht
    </Button>
  );
};
export default BackToYachtButton;
